import { Input, Translation } from '@ps/web-shared-components';
import React from 'react';
import { Field } from 'react-final-form';

import {
  TXTCLI_For_added_securityX_you_must_c_ELL,
  TXTCLI_Please_confirm_the_last_N0_dig_ELL
} from './StrongPwdReset.messages.json';

interface Props {
  data?: { id?: number; question?: string }[];
}
const StrongPwdReset: React.FC<Props> = ({ data }) => (
  <>
    <Translation tagName="p" {...TXTCLI_For_added_securityX_you_must_c_ELL} />
    {data?.map((item, index) => (
      <Field name="question" key={item.id}>
        {({ input: { value } }) => <Input id={`answer${index}`} label={item.question as string} />}
      </Field>
    ))}
    <Field name="ssn">
      {({ input: { value } }) => (
        <Input id="ssn" label={TXTCLI_Please_confirm_the_last_N0_dig_ELL} values={{ 0: '4' }} />
      )}
    </Field>
  </>
);

export default StrongPwdReset;
